import axiosapi from "./axiosAPI";

// Get All Religions
export const getAllReligions = async (
    setReligions,
    setFetcherror
) => {
    
	try{
		const res =await axiosapi.get("/religions");
        setReligions(res.data.data ? res.data.data : {});

	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Religions");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Religions");
		}
		
	}
	
};



// Get One Religion
export const getOneReligion = async (
    pkid,
    setFetcherror,  
    setReligion
    
)=>{
	try{
		const res =await axiosapi.get(`/religions/${pkid}`);
        setReligion(res.data.body);
       
	}
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Fetch Religion");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Fetch Religion");
		}
		
	}
	
};


// Create New Religion
export const createReligion = async (
    religion,
    setReligion,
    setFetcherror,
    handleAllToasts,
    setReligions

) => {


    if (!religion ) {
        handleAllToasts(2, "No Religion Provided"); 
            return; 
        }

    const PushItem = {
            name: religion,
        };

    try{
        await axiosapi.post("/religions/",PushItem );
        setReligion("");
        handleAllToasts(1, "Religion Created Successfully");
        getAllReligions(setReligions, setFetcherror);
    }
    catch(err){
        if(err.response){
            //Error Obtained from Backend not in 200
            console.log(err.response.data);
            console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Could Not Create New Religion");
            handleAllToasts(2, "Could Not update The Religion");
            
            
        }else{
            //No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Could Not Create New Religion");
            handleAllToasts(2, "Could Not update The Religion");
            
        }
        
    }
    
}


// Edit Existing Religion

export const editReligion = async (
    religionpkid,
    religion,
    setReligion,
    setFetcherror,
    handleAllToasts,
    setReligions
              
        ) => {

            if (!religion) {
                handleAllToasts(2, "No Religion Name Provided"); 
                    return;  
                }

            const PushItem = {

                    id:religionpkid,
                    name: religion,
                };

            try{
                await axiosapi.patch("/religions/",PushItem );
                setReligion("");
                handleAllToasts(1, "Religion Updated Successfully");
                getAllReligions(setReligions, setFetcherror);
            }
            catch(err){
                if(err.response){
                    //Error Obtained from Backend not in 200
                    console.log(err.response.data);
                    console.log(err.response.status);
                    console.log(err.response.headers);
                    setFetcherror("Could Not Update Religion");
                    handleAllToasts(2, "Could Not Update Religion");
                    
                    
                }else{
                    //No response Obtained from the server.
                    console.log(`Error: ${err.message}`);
                    setFetcherror("Could Not Update Religion");
                    handleAllToasts(2, "Could Not Update Religion");
                    
                }
                
            }
            
};



// Delete Existing Religion.

export const deleteReligion = async (
    religionpkid,
    setReligions,
    setFetcherror,
    handleAllToasts
)=>{
    try {
        const res = await axiosapi.delete(`/religions/${religionpkid}`);
        handleAllToasts(1, "Religion Deleted Successfully");
        getAllReligions(setReligions, setFetcherror);
    }
	catch(err){
		if(err.response){
			//Error Obtained from Backend not in 200
			console.log(err.response.data);
			console.log(err.response.status);
            console.log(err.response.headers);
            setFetcherror("Error: Could Not Delete Religion");
            handleAllToasts(2,"Error: Could Not Delete Religion");
			
		}else{
			//No response Obtained from the server.
            console.log(`Error: ${err.message}`);
            setFetcherror("Error: Could Not Delete Religion");
            handleAllToasts(2,"Error: Could Not Delete Religion");
		}
		
	}
	
};